module.exports = __webpack_public_path__ + "img/Cover.54347083.jpg";